
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import MultiSelect from "@khanacademy/react-multi-select";
import CustomTable from "../2/Controls/CustomTable";
import ReportViewPage from "./ReportViewPage";
import Input from "../2/Controls/Input";
import Autocompletesearch from "../2/Controls/Autocompletesearch"
import Pagination from "../2/Controls/Pagination";
import FloatingWidget from "../2/Controls/FloatingWidget";
import "../2/Controls/FloatingWidget.css";
import NewImageButton from "../2/Controls/NewImageButton";
import { getRenderer } from "./ReportRenderers";
class Report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTransactionType: null,
      selectedStores: [],
      storeList: [],
      showStorePopup: false,
      loading: false,
      reportData: [],
      totalCount: 0,
      categoryData: [],
      partyData: [],
      partySearch: "",
      expenseCategoryData: [],
      vendorData: [],
      customerData: [],
      storeLocation: [],
      inStockTotal: {},
      currentPage: 1,
      rowsPerPage: 25,
      activeParams: null,
      filterComponents: [],
      backendColumns: [],
      filterValues: {},
      isInitialized: false,
      exportLoading: false,
      showExportWidget: false,
      exportReportName: ""
    };

    // Bind all methods
    this.getTodayDate = this.getTodayDate.bind(this);
    this.initializeFilters = this.initializeFilters.bind(this);
    this.fetchDataWithFilters = this.fetchDataWithFilters.bind(this);
    this.formatDate = this.formatDate.bind(this);
    this.generateColumnsFromData = this.generateColumnsFromData.bind(this);
    this.formatHeaderName = this.formatHeaderName.bind(this);
    this.fetchPartyData = this.fetchPartyData.bind(this);
    this.fetchExpenseCategoryData = this.fetchExpenseCategoryData.bind(this);
    this.fetchVendorData = this.fetchVendorData.bind(this);
    this.fetchCategoriesData = this.fetchCategoriesData.bind(this);
    this.fetchStoreLocationData = this.fetchStoreLocationData.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleApplyFilters = this.handleApplyFilters.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);
    this.handleExport = this.handleExport.bind(this);
    this.renderFilterComponent = this.renderFilterComponent.bind(this);
    this.generateYearOptions = this.generateYearOptions.bind(this);
    this.generateMonthOptions = this.generateMonthOptions.bind(this);
    this.getDynamicColumns = this.getDynamicColumns.bind(this);
    this.getColumns = this.getColumns.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleRowsPerPageChange = this.handleRowsPerPageChange.bind(this);
  }

  componentDidMount() {
    console.log("Full location object:", this.props.location);
    console.log("Search string:", this.props.location.search);
    console.log("Route params:", this.getRouteParams());


    this.fetchCategoriesData();
    const stateFilters = this.props.location.state &&
      this.props.location.state.hasOwnProperty('filters') ?
      this.props.location.state.filters : {};
    const initialFilters = this.initializeFilters(stateFilters);
    this.setState({
      filterValues: initialFilters,
      filterComponents: this.getFilterComponents(),
      isInitialized: true
    }, () => {
      this.fetchDataWithFilters(initialFilters);

    });
  }

  getFilterComponents() {
    const reportConfig = this.getReportConfig();
    if (!reportConfig || !reportConfig.filters) return [];

    return reportConfig.filters.map(filter => this.renderFilterComponent(filter));
  }

  componentDidUpdate(prevProps, prevState) {
    // Check if route params changed
    const currentRouteParams = this.getRouteParams();
    const prevRouteParams = this.getRouteParamsFromProps(prevProps);

    if (JSON.stringify(currentRouteParams) !== JSON.stringify(prevRouteParams)) {
      const initialFilters = this.initializeFilters();
      this.setState({
        filterValues: initialFilters,
        filterComponents: this.getFilterComponents(),
        currentPage: 1
      }, () => {
        this.fetchDataWithFilters(initialFilters);
      });
      return;
    }

    // Check if filterValues changed and update filterComponents
    if (JSON.stringify(prevState.filterValues) !== JSON.stringify(this.state.filterValues) ||
      JSON.stringify(prevState.vendorData) !== JSON.stringify(this.state.vendorData)) {
      this.setState({
        filterComponents: this.getFilterComponents()
      });
    }
    if (JSON.stringify(prevState.filterValues) !== JSON.stringify(this.state.filterValues) ||
      JSON.stringify(prevState.customerData) !== JSON.stringify(this.state.customerData)) {
      this.setState({
        filterComponents: this.getFilterComponents()
      });
    }
  }
  // Helper to get fresh Redux state
  getReduxState() {
    let inventoryTransactionTypes = [];
    let salesTransactionType = [];

    // Inventory Transaction Types
    this.props.config.TransactionTypes
      .filter((e) => e.Module === "inventory" && !e.IsDeleted)
      .forEach((e) => {
        inventoryTransactionTypes.push(e);

      });

    // Sales Transaction Types
    this.props.config.TransactionTypes
      .filter((e) => e.Module === "sales" && !e.IsDeleted)
      .forEach((e) => {
        salesTransactionType.push(e);
      });

    return {
      inventoryTransactionType: inventoryTransactionTypes,
      salesTransactionType: salesTransactionType,
      registrationData: this.props.registration.registration,

      productCustomFields: this.props.config.CustomFields.filter(
        (customField) => customField.ModuleName === "Product"
      ),
   

      customerCustomField: this.props.config.CustomFields.filter(
        (customField) => customField.ModuleName === "Customer"
      ),

      vendorCustomField: this.props.config.CustomFields.filter(
        (customField) => customField.ModuleName === "Vendor"
      ),

      user: this.props.user.user,
      singleStore: this.props.user.store,
      storesList: this.props.config.UserStores.filter(
        (store) => store.key !== ""
      ),
      isPincode: false,
    };
  }

  getRouteParams() {
    const queryParams = new URLSearchParams(this.props.location.search);
    return {
      reportType: queryParams.get('name'),
      reportModuleType: queryParams.get('type'),
      transactionTypeId: queryParams.get('transactionTypeId'),
    };
  }

  getRouteParamsFromProps(props) {
    const queryParams = new URLSearchParams(props.location.search);
    return {
      reportType: queryParams.get('name'),
      reportModuleType: queryParams.get('type'),
      transactionTypeId: queryParams.get('transactionTypeId'),
    };
  }

  getReduxStateFromPrev(prevProps) {
    return this.getReduxState();
  }

  getReportConfig() {
    const { reportType, reportModuleType } = this.getRouteParams();
    const isInventoryModule = reportModuleType === 'Inventory';
    return isInventoryModule
      ? { ...this.props.config.ReportConfig.allInventoryReport, title: reportType }
      : this.props.config.ReportConfig[reportType];
  }

  getTodayDate() {
    return new Date().toISOString().split('T')[0];
  }

  initializeFilters(stateFilters = {}) {
    console.log("stateFilters", stateFilters);
    const reportConfig = this.getReportConfig();
    const { singleStore } = this.getReduxState();
    const initialFilters = {};
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear().toString();
    const currentMonth = (currentDate.getMonth() + 1).toString().padStart(2, '0');

    reportConfig && reportConfig.filters && reportConfig.filters.forEach(filter => {
      if (stateFilters[filter.field] !== undefined) {
        initialFilters[filter.field] = stateFilters[filter.field];
      }
      else if (filter.type === "singleStore") {
        initialFilters[filter.field] = (singleStore && singleStore.key) ? singleStore.key : "all";
      } else if (filter.type === "multipleStore") {
        initialFilters[filter.field] = singleStore && singleStore.key ? [singleStore.key] : [];
      } else if (filter.type === "date" && (!filter.hasOwnProperty('dontSelectByDefaultDate') || !filter.dontSelectByDefaultDate)) {
        initialFilters[filter.field] = this.getTodayDate();
      } else if (filter.type === "year") {
        initialFilters[filter.field] = (filter.hasOwnProperty('defaultValue') && filter.defaultValue) ? filter.defaultValue : currentYear;
      } else if (filter.type === "month") {
        initialFilters[filter.field] = (filter.hasOwnProperty('defaultValue') && filter.defaultValue) ? filter.defaultValue : currentMonth;
      } else if (filter.type === "salesTransactionType") {
        initialFilters[filter.field] = (filter.hasOwnProperty('defaultValue') && filter.defaultValue) ? filter.defaultValue : "";
      } else {
        initialFilters[filter.field] = (filter.hasOwnProperty('defaultValue') && filter.defaultValue) ? filter.defaultValue : "";
      }
    });
    return initialFilters;
  }

  async fetchDataWithFilters(filters = this.state.filterValues) {
    const reportConfig = this.getReportConfig();
    const { singleStore, user, storesList } = this.getReduxState();
    const { transactionTypeId, reportModuleType } = this.getRouteParams();
    const paginationFromBackend = reportConfig && reportConfig.hasOwnProperty('paginationFromBackend') ? reportConfig.paginationFromBackend : false;
    const generateColumnFromBaceknd = reportConfig && reportConfig.hasOwnProperty('generateColumnFromBaceknd') ? reportConfig.generateColumnFromBaceknd : false;
    const { currentPage, rowsPerPage, storeList } = this.state;

    try {
      this.setState({ loading: true });
      const params = {
        ...(reportConfig && reportConfig.hasOwnProperty('defaultParams') ? reportConfig.defaultParams : {}),
        ...(reportConfig && reportConfig.hasOwnProperty('defaultSelectedStore') && reportConfig.defaultSelectedStore && singleStore && singleStore.key && { searchStore: singleStore.key }),
        ...(reportConfig && reportConfig.hasOwnProperty('passSingleStoreId') && reportConfig.passSingleStoreId && (filters.store !== "all") && { storeID: filters.store }),
        ...(reportModuleType === 'Inventory' && transactionTypeId && { searchTransactionType: transactionTypeId }),
        ...(reportConfig && reportConfig.hasOwnProperty('fromStoreId') && reportConfig.fromStoreId && singleStore && singleStore.key && { fromStoreID: singleStore.key }),
        ...(reportConfig && reportConfig.hasOwnProperty('passUserRole') && reportConfig.passUserRole && user && user.Role && { userRole: user.Role }),
        registrationID: user && user.hasOwnProperty('RegistrationID') ? user.RegistrationID : null
      };

      if (paginationFromBackend) {
        params.from = (currentPage - 1) * rowsPerPage;
        params.size = rowsPerPage;
      }

      // Normalize stores
      const stores = Array.isArray(storesList) && storesList.length > 0
        ? storesList
        : singleStore ? [singleStore] : [];

      // Handle multiple store selection
      // In fetchDataWithFilters - corrected store handling section
      if (filters.store) {
        var paramName = 'store';
        if (reportConfig && reportConfig.hasOwnProperty('paramMappings') && reportConfig.paramMappings.hasOwnProperty('store')) {
          paramName = reportConfig.paramMappings.store;
        }

        // Get stores from Redux state (FIX: you need to define stores)
        const { storesList, singleStore } = this.getReduxState();
        const stores = Array.isArray(storesList) && storesList.length > 0
          ? storesList
          : singleStore ? [singleStore] : [];

        // Ensure filters.store is always treated as an array
        let storeArray = Array.isArray(filters.store) ? filters.store : [filters.store];

        // Check if "all" is selected (either as the only value or part of the array)
        const isAllSelected = storeArray.includes("all");

        if (isAllSelected) {
          // If "all" is selected, pass ALL available stores
          const allStores = stores.map(store => ({
            label: store.StoreName,
            value: store.key
          }));
          params[paramName] = JSON.stringify(allStores);
        } else {
          // Filter out any invalid values (but keep regular store IDs)
          storeArray = storeArray.filter(key => key && key !== "all");

          if (storeArray.length > 0) {
            var mappedStores = storeArray.map(function (key) {
              var storeName = key;
              for (var i = 0; i < stores.length; i++) {
                if (stores[i].key === key) {
                  storeName = stores[i].StoreName;
                  break;
                }
              }
              return {
                label: storeName,
                value: key
              };
            });

            params[paramName] = JSON.stringify(mappedStores);
          }
        }
      }
      // if (storeList && storeList.length > 0) {
      //   const paramName = (reportConfig && reportConfig.paramMappings && reportConfig.paramMappings.hasOwnProperty('store')) ? reportConfig.paramMappings.store : 'store';
      //   params[paramName] = JSON.stringify(storeList.map(s => ({
      //     label: stores.find(store => store.key === s.key) && stores.find(store => store.key === s.key).StoreName ? stores.find(store => store.key === s.key).StoreName : s.key,
      //     value: s.key
      //   })));
      // }

      // Handle date filters, year/month, etc.
      if (filters.show) params[(reportConfig && reportConfig.paramMappings && reportConfig.paramMappings.hasOwnProperty('show')) ? reportConfig.paramMappings.show : 'show'] = filters.show;
      if (filters.fromDate) params[(reportConfig && reportConfig.paramMappings && reportConfig.paramMappings.hasOwnProperty('fromDate')) ? reportConfig.paramMappings.fromDate : 'fromDate'] = this.formatDate(filters.fromDate);
      if (filters.toDate) params[(reportConfig && reportConfig.paramMappings && reportConfig.paramMappings.hasOwnProperty('toDate')) ? reportConfig.paramMappings.toDate : 'toDate'] = this.formatDate(filters.toDate);
      if (filters.year && filters.month) {
        const year = parseInt(filters.year, 10);
        const month = parseInt(filters.month, 10);
        const firstDay = `${year}-${month.toString().padStart(2, '0')}-01`;
        const lastDayDate = new Date(year, month, 0);
        const lastDay = `${year}-${month.toString().padStart(2, '0')}-${lastDayDate.getDate()}`;
        params[(reportConfig && reportConfig.paramMappings && reportConfig.paramMappings.hasOwnProperty('year')) ? reportConfig.paramMappings.year : 'monthStartdate'] = firstDay;
        params[(reportConfig && reportConfig.paramMappings && reportConfig.paramMappings.hasOwnProperty('month')) ? reportConfig.paramMappings.month : 'monthEndDate'] = lastDay;
      }

      reportConfig && reportConfig.filters && reportConfig.filters.forEach(filter => {
        if (filter.type === "date") {
          const value = filters[filter.field];
          if (value) params[(reportConfig.paramMappings && reportConfig.paramMappings.hasOwnProperty(filter.field)) ? reportConfig.paramMappings[filter.field] : filter.field] = this.formatDate(value);
        } else if (filter.type !== "singleStore" && filter.type !== "multipleStore" && filter.type !== "date" && filter.type !== "year" && filter.type !== "month") {
          const value = filters[filter.field];
          if (value) {
            if (filter.type === "salesTransactionType" && value !== "") {
              params[(reportConfig.paramMappings && reportConfig.paramMappings.hasOwnProperty(filter.field)) ? reportConfig.paramMappings[filter.field] : filter.field] = value;
            } else if (typeof value === 'object' && value !== null) {
              Object.keys(value).forEach(property => {
                const paramKey = `${filter.field}.${property}`;
                const paramName = (reportConfig.paramMappings && reportConfig.paramMappings.hasOwnProperty(paramKey)) ? reportConfig.paramMappings[paramKey] : null;
                if (paramName && value[property]) params[paramName] = value[property];
              });
            } else {
              params[(reportConfig.paramMappings && reportConfig.paramMappings.hasOwnProperty(filter.field)) ? reportConfig.paramMappings[filter.field] : filter.field] = value;
            }
          }
        }
      });

      this.setState({ activeParams: params });

      let res = reportConfig && reportConfig.hasOwnProperty('isExternalAPIURL') && reportConfig.isExternalAPIURL
        ? await axios.get(reportConfig.apiEndpoint, { params })
        : await this.props.getReportData(reportConfig.apiEndpoint, params);
      const response = res;

      if (response && response.code === "0") {
        const data = (response && response.hasOwnProperty('searchResult')) ? response.searchResult : (response && response.hasOwnProperty('data')) ? response.data : [];
        if (generateColumnFromBaceknd && data.length) {
          this.setState({ backendColumns: this.generateColumnsFromData(data) });
        }
        if (paginationFromBackend) {
          this.setState({ reportData: data, inStockTotal: (response && response.hasOwnProperty('instockTotals')) ? response.instockTotals : {}, totalCount: (response && response.hasOwnProperty('totalItemsCount')) ? response.totalItemsCount : 0 });
        } else {
          this.setState({ reportData: data, totalCount: data.length || 0, inStockTotal: (response && response.hasOwnProperty('instockTotals')) ? response.instockTotals : {} });
        }
      } else {
        this.props.getToastr((response && response.hasOwnProperty('message')) ? response.message : "Failed to fetch data");
        this.setState({ reportData: [], inStockTotal: {}, totalCount: 0 });
      }
    } catch (error) {
      console.error("Fetch error:", error);
      this.props.getToastr((error.response && error.response.data && error.response.data.hasOwnProperty('message')) ? error.response.data.message : "An error occurred");
      this.setState({ reportData: [], inStockTotal: {}, totalCount: 0 });
    } finally {
      this.setState({ loading: false });
    }
  }

  formatDate(dateString) {
    return new Date(dateString).toISOString().split('T')[0];
  }

  generateColumnsFromData(rows) {
    // Merge the keys of every row: a field (e.g. a newly added payment type)
    // may be absent from the first row but present in others. For each key,
    // sample the first row that actually has a value for it.
    const sampleData = {};
    (Array.isArray(rows) ? rows : [rows]).forEach((row) => {
      Object.keys(row || {}).forEach((key) => {
        if (!sampleData.hasOwnProperty(key) || sampleData[key] === null || sampleData[key] === undefined) {
          sampleData[key] = row[key];
        }
      });
    });
    const reportConfig = this.getReportConfig();
    const exclude = (reportConfig && reportConfig.hasOwnProperty('excludeColumnFromTotal')) ? reportConfig.excludeColumnFromTotal : [];
    const forceNumeric = (reportConfig && reportConfig.hasOwnProperty('forceColumnsFortotal')) ? reportConfig.forceColumnsFortotal : [];
    return Object.keys(sampleData).map(key => {
      const value = sampleData[key];
      const isNumeric = !isNaN(parseFloat(value)) && isFinite(value);

      const isExcluded = exclude.includes(key);
      const shouldTreatAsNumeric = !isExcluded && (forceNumeric.includes(key) || isNumeric);
      return {
        field: key,
        headerName: this.formatHeaderName(key),
        type: shouldTreatAsNumeric ? 'number' : typeof value,
        ...(reportConfig && reportConfig.hasOwnProperty('showTotal') && reportConfig.showTotal && shouldTreatAsNumeric && !exclude.includes(key) && { showTotal: true })
      };
    });
  }

  formatHeaderName(key) {
    return key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()).trim();
  }

  async fetchPartyData(searchPartyQuery = null) {
    try {
      this.props
        .searchParty(
          this.props.user.user.RegistrationID,
          this.props.user.store.key,
          searchPartyQuery
        )
        .then((result) => {
          this.setState({ partyData: result.searchResult });
        });
    } catch (err) {
      console.error("Error fetching party:", err);
    }
  }

  async fetchExpenseCategoryData() {
    try {
      this.props
        .getExpenseCategories(
          this.props.user.store.key
        )
        .then((expenseCategories) => {
          this.setState({ expenseCategoryData: expenseCategories });
        });
    } catch (err) {
      console.error("Error fetching expense categories:", err);
    }
  }

  async fetchVendorData(searchText = "") {
    try {
      const response = await this.props.getVendors(0, searchText ? 50 : 10, "active", searchText);
      const allVendors = (response && response.hasOwnProperty('searchResult')) ? response.searchResult : [];
      const vendorSources = allVendors.map(vendor => ({
        key: (vendor.hasOwnProperty('id') && vendor.id) ? vendor.id : ((vendor.hasOwnProperty('key') && vendor.key) ? vendor.key : null),
        ...vendor,
      }));
      return vendorSources;
      // this.setState({ vendorData: vendorSources });
    } catch (err) {
      console.error("Error fetching vendors:", err);
    }
  }

  async fetchCustomerData(searchText = "") {
    try {
      const response = await this.props.searchCustomer(this.props.user.user.RegistrationID, this.props.user.store.key, searchText);
      const allCustomers = (response && response.hasOwnProperty('searchResult')) ? response.searchResult : [];
      return allCustomers;
      // this.setState({ vendorData: vendorSources });
    } catch (err) {
      console.error("Error fetching customers:", err);
    }
  }

  async fetchCategoriesData() {
    let categories = this.props.config.ProductCategories.filter(
      (e) => e.ParentID === "" && !e.IsDeleted
    );
    console.log("categories", categories);
    this.setState({ categoryData: categories });
  }

  async fetchStoreLocationData(storeId) {
    try {
      let storeLocationsTmp = [];
      let storeLocations = [];
      let searchStoreLocation = "";
      storeLocationsTmp = await this.props.getStoreLocations(
        storeId
      );
      storeLocations = storeLocationsTmp.filter((f) => !f.IsDeleted);
      searchStoreLocation =
        storeLocations.length > 0 ? storeLocations[0].key : "";

      this.setState({ storeLocation: storeLocations });
    } catch (err) {
      this.props.getToastr("Please try again !");
      console.error("Error fetching storeLocation:", err);
    }
  }

  handleFilterChange(field, value) {
    this.setState(prev => ({ filterValues: { ...prev.filterValues, [field]: value } }));
  }

  handleApplyFilters() {
    this.setState({ currentPage: 1 }, () => this.fetchDataWithFilters(this.state.filterValues));
  }

  handleRefresh() {
    const fresh = this.initializeFilters();
    this.setState({ filterValues: fresh, currentPage: 1 }, () => this.fetchDataWithFilters(fresh));
  }

  async handleExport(e) {
    const reportConfig = this.getReportConfig();
    const { activeParams, backendColumns } = this.state;
    const { user } = this.getReduxState();
    const { reportType } = this.getRouteParams();
    const isInventory = this.getRouteParams().reportModuleType === 'Inventory';
    const genBackend = (this.getReportConfig() && this.getReportConfig().hasOwnProperty('generateColumnFromBaceknd') && this.getReportConfig().generateColumnFromBaceknd) || false;
    const reqData = {
      reportName: isInventory ? "allInventoryReport" : reportType,
      format: e,
      filter: { ...activeParams, registrationID: user.RegistrationID },
      requestId: user.RegistrationID,
      columns:
        reportConfig &&
          reportConfig.hasOwnProperty("exportColumns") &&
          reportConfig.exportColumns
          ? reportConfig.exportColumns
          : (genBackend ? backendColumns : this.getDynamicColumns()),
    };
    this.setState({
      exportLoading: true
    })
    try {
      const res = await this.props.sendReportExportRequest('/report/downloadrequest', reqData);
      if (res.code === "0") {
        this.setState({
          showExportWidget: true,
          exportReportName: reportType,
          exportLoading: true
        });
      } else {
        this.props.getToastr("Export failed");
      }
    } catch (error) {
      this.props.getToastr((error.response && error.response.data && error.response.data.hasOwnProperty('message')) ? error.response.data.message : "Export failed");
    }
    finally {
      this.setState({
        exportLoading: false
      })
    }
  }

  renderFilterComponent(filter) {
    const { filterValues, categoryData, partyData, expenseCategoryData, vendorData, customerData, storeLocation, selectedStores, stores } = this.state;
    const { storesList, singleStore, salesTransactionType, inventoryTransactionType, productCustomFields, customerCustomField, vendorCustomField, isPincode } = this.getReduxState();
    const storeOptions = Array.isArray(storesList) && storesList.length ? storesList : (singleStore ? [singleStore] : []);

       console.log("productCustomFields",productCustomFields);
    if (filter.showWhen && !filterValues[filter.showWhen]) return null;
    if (filter.hasOwnProperty('showOnlyForPosible') && filter.showOnlyForPosible && isPincode) return null;

    switch (filter.type) {
      case "category":
        console.log("Rendering category filter with data:", categoryData);
        return <Autocompletesearch
          value={filterValues[filter.field] && filterValues[filter.field].label ? filterValues[filter.field].label : ""}
          label={filter.label}
          data={categoryData}
          onChange={(value) => {
            console.log("Category input changed:", value);
          }}
          filterKey={["Name"]}
          defaultDataCount={100}
          onSelect={(item) => this.handleFilterChange(filter.field, { label: item.Name, value: item.key })}
          placeholder="Search Category"
          renderSuggestion={(item) => <p>{item.Name}</p>}
        />;

      case "party":
        return <Autocompletesearch value={filterValues[filter.field] && filterValues[filter.field].label ? filterValues[filter.field].label : ""} label={filter.label} data={partyData} filterKey={["PartyName", "PartyCode", "PhoneNo", "EmailID"]} defaultDataCount={10} onChange={(v) => this.setState({ partySearch: v })} onSelect={(item) => this.handleFilterChange(filter.field, { label: item.PartyName, value: item.key })} placeholder="Search party" renderSuggestion={(p) => <div><div>{p.PartyName}</div>{p.hasOwnProperty('PartyCode') && p.PartyCode && <div className="text-sm">{p.PartyCode}</div>}{p.hasOwnProperty('PhoneNo') && p.PhoneNo && <div className="text-sm">{p.PhoneNo}</div>}{p.hasOwnProperty('EmailID') && p.EmailID && <div className="text-sm">{p.EmailID}</div>}</div>} />;

      case "expenseCategory":
        return <Autocompletesearch value={filterValues[filter.field] && filterValues[filter.field].label ? filterValues[filter.field].label : ""} label={filter.label} data={expenseCategoryData.map(c => ({ label: c.ExpenseCategory, value: c.key }))} filterKey={["label"]} defaultDataCount={10} onSelect={(item) => this.handleFilterChange(filter.field, { label: item.label, value: item.value })} placeholder="Search Category" renderSuggestion={(item) => <p>{item.label}</p>} />;

      case "vendor":
        return <Autocompletesearch
          value={
            filterValues[filter.field] && filterValues[filter.field].label
              ? filterValues[filter.field].label
              : ""
          }
          label={filter.label}
          data={vendorData}
          onChange={(v) => {
            this.fetchVendorData(v).then((vendorData) => {
              console.log("vendorData", vendorData);
              this.setState({ vendorData });
            });
          }}
          filterKey={["VendorFirstName", "PhoneNo", "EmailID", "VendorCode"]}
          defaultDataCount={100}
          onSelect={(item) =>
            this.handleFilterChange(filter.field, {
              label: item.VendorFirstName,
              value: item.key,
            })
          }
          placeholder="Search Vendor"
          renderSuggestion={(item) => (
            <div>
              <p style={{ fontWeight: "500", margin: "0" }}>
                {item.VendorCode} {item.VendorFirstName}
              </p>

              {item.PhoneNo && (
                <p style={{ fontSize: "14px", margin: "0" }}>
                  {item.PhoneNo}
                </p>
              )}

              {item.EmailID && (
                <p style={{ fontSize: "14px", margin: "0" }}>
                  {item.EmailID}
                </p>
              )}
            </div>
          )}
        />

      case "customer":
        return <Autocompletesearch
          value={
            filterValues[filter.field] && filterValues[filter.field].label
              ? filterValues[filter.field].label
              : ""
          }
          label={filter.label}
          data={customerData}
          onChange={(v) => {
            this.fetchCustomerData(v).then((customerData) => {
              this.setState({ customerData });
            });
          }}
          filterKey={["FirstName", "LastName", "EmailID", "PhoneNo", "CustomerCode"]}
          defaultDataCount={100}
          onSelect={(item) =>
            this.handleFilterChange(filter.field, {
              label: item.FirstName + item.LastName,
              value: item.key,
            })
          }
          placeholder="Search Customer"
          renderSuggestion={(item) => (
            <div>
              <p style={{ fontWeight: "500", margin: "0" }}>
                {item.CustomerCode} {item.FirstName} {item.LastName}
              </p>

              {item.PhoneNo && (
                <p style={{ fontSize: "14px", margin: "0" }}>
                  {item.PhoneNo}
                </p>
              )}

              {item.EmailID && (
                <p style={{ fontSize: "14px", margin: "0" }}>
                  {item.EmailID}
                </p>
              )}
            </div>
          )}
        />
      case "singleStore":
        return (
          <Input
            type="select"
            label={filter.label}
            value={filterValues[filter.field] || "all"}
            onChange={(value) => {
              this.handleFilterChange(filter.field, value);
              if (value !== "all") {
                this.fetchStoreLocationData(value);
              } else {
                this.setState({ storeLocation: [] });
                this.handleFilterChange("storeLocation", "");
              }
            }}
          >
            <option value="all">All Stores</option>
            {storeOptions.map(s => (
              <option key={s.key} value={s.key}>{s.StoreName}</option>
            ))}
          </Input>
        );

      case "storeLocation":
        return (
          <Input
            type="select"
            label={filter.label}
            value={filterValues[filter.field] || ""}
            onChange={(value) => this.handleFilterChange(filter.field, value)}
          >
            <option value="">Select Location</option>
            {storeLocation.map(loc => (
              <option key={loc.id} value={loc.id}>{`${loc.LocationCode} ${loc.LocationName}`}</option>
            ))}
          </Input>
        );

      case "multipleStore":
        const multiStoreOptions = storeOptions.map(s => ({
          label: s.StoreName,
          value: s.key
        }));

        // Get current selected values - ensure it's always an array of strings
        let currentSelected = filterValues[filter.field];
        if (!currentSelected || !Array.isArray(currentSelected)) {
          currentSelected = singleStore && singleStore.key ? [singleStore.key] : [];
        }

        return (
          <div style={{ zIndex: 100 }}>
            <label>{filter.label}</label>
            <MultiSelect
              selectAllLabel="All Stores"
              options={multiStoreOptions}
              selected={currentSelected}
              onSelectedChanged={(selected) => {
                this.handleFilterChange(filter.field, selected);
              }}
            />
          </div>
        );
      case "salesTransactionType":
        return (
          <Input
            type="select"
            label={filter.label}
            value={filterValues[filter.field] || ""}
            onChange={(value) => this.handleFilterChange(filter.field, value)}
          >
            <option value="">All transaction</option>
            {salesTransactionType.map(t => (
              <option key={t.key} value={t.key}>{t.TransactionType}</option>
            ))}
          </Input>
        );

      case "inventoryTransactionType":
        return (
          <Input
            type="select"
            label={filter.label}
            value={filterValues[filter.field] || ""}
            onChange={(value) => this.handleFilterChange(filter.field, value)}
          >
            {inventoryTransactionType.map(t => (
              <option key={t.key} value={t.key}>{t.TransactionType}</option>
            ))}
          </Input>
        );

      case "select":
        return (
          <Input
            type="select"
            label={filter.label}
            value={filterValues[filter.field] || ""}
            onChange={(value) => this.handleFilterChange(filter.field, value)}
          >
            <option value="">Select</option>
            {filter.options && filter.options.map((opt, idx) => (
              <option key={idx} value={opt.value}>{opt.label}</option>
            ))}
          </Input>
        );

      case "date":
        return (
          <Input
            type="date"
            label={filter.label}
            value={filterValues[filter.field] || ""}
            onChange={(value) => this.handleFilterChange(filter.field, value)}
          />
        );

      case "text":
        return (
          <Input
            type="text"
            label={filter.label}
            placeholder={filter.hasOwnProperty('placeholder') ? filter.placeholder : ""}
            value={filterValues[filter.field] || ""}
            onChange={(value) => this.handleFilterChange(filter.field, value)}
          />
        );

      case "number":
        return (
          <Input
            type="number"
            label={filter.label}
            placeholder={filter.hasOwnProperty('placeholder') ? filter.placeholder : ""}
            value={filterValues[filter.field] || ""}
            onChange={(value) => this.handleFilterChange(filter.field, value)}
          />
        );

      case "customSwitch":
        return (
          <div style={{ marginBottom: "16px" }}>
            {filter.label && <label>{filter.label}</label>}
            <div>
              <Input
                type="switch"
                value={filterValues[filter.field] || false}
                onChange={(checked) => this.handleFilterChange(filter.field, checked)}
              />
            </div>
          </div>
        );

      case "year":
        return (
          <Input
            type="select"
            label={filter.label}
            value={filterValues[filter.field] || ""}
            onChange={(value) => this.handleFilterChange(filter.field, value)}
          >
            <option value="">Select Year</option>
            {this.generateYearOptions().map(year => (
              <option key={year.value} value={year.value}>{year.label}</option>
            ))}
          </Input>
        );

      case "month":
        return (
          <Input
            type="select"
            label={filter.label}
            value={filterValues[filter.field] || ""}
            onChange={(value) => this.handleFilterChange(filter.field, value)}
          >
            <option value="">Select Month</option>
            {this.generateMonthOptions().map(month => (
              <option key={month.value} value={month.value}>{month.label}</option>
            ))}
          </Input>
        );

      case "productCustomField":
        return (
          <Input
            type="text"
            label={productCustomFields && productCustomFields.hasOwnProperty(`CustomField${filter.customField}Name`) ? productCustomFields[`CustomField${filter.customField}Name`] : filter.label}
            placeholder={filter.hasOwnProperty('placeholder') ? filter.placeholder : ""}
            value={filterValues[filter.field] || ""}
            onChange={(value) => this.handleFilterChange(filter.field, value)}
          />
        );

      case "customerCustomField":
        return (
          <Input
            type="text"
            label={customerCustomField && customerCustomField.hasOwnProperty(`CustomField${filter.customField}Name`) ? customerCustomField[`CustomField${filter.customField}Name`] : filter.label}
            placeholder={filter.hasOwnProperty('placeholder') ? filter.placeholder : ""}
            value={filterValues[filter.field] || ""}
            onChange={(value) => this.handleFilterChange(filter.field, value)}
          />
        );

      case "vendorCustomField":
        return (
          <Input
            type="text"
            label={vendorCustomField && vendorCustomField.hasOwnProperty(`CustomField${filter.customField}Name`) ? vendorCustomField[`CustomField${filter.customField}Name`] : filter.label}
            placeholder={filter.hasOwnProperty('placeholder') ? filter.placeholder : ""}
            value={filterValues[filter.field] || ""}
            onChange={(value) => this.handleFilterChange(filter.field, value)}
          />
        );

      default: return null;
    }
  }

  generateYearOptions() {
    const years = [];
    for (let y = new Date().getFullYear(); y >= 2018; y--) years.push({ label: String(y), value: String(y) });
    return years;
  }

  generateMonthOptions() {
    return Array.from({ length: 12 }, (_, i) => ({ label: new Date(0, i).toLocaleString('default', { month: 'long' }), value: (i + 1).toString().padStart(2, '0') }));
  }


  shouldShowAction(action, row) {
    // If no condition defined, always show
    if (!action.hasOwnProperty('condition')) return true;

    try {
      // If condition is a string, evaluate it as a function
      if (typeof action.condition === 'string') {
        // Safely evaluate the condition function
        const conditionFunc = new Function('row', 'return ' + action.condition);
        return conditionFunc(row);
      }
      // If condition is already a function
      else if (typeof action.condition === 'function') {
        return action.condition(row);
      }
      return true;
    } catch (error) {
      console.error('Error evaluating action condition:', error);
      return true;
    }
  }

  // Method to process actions with conditions
  processActionColumn(column) {
    if (column.type !== 'action' || !column.hasOwnProperty('actions')) return column;

    let actionsArray;
    try {
      // Parse actions if it's a string
      actionsArray = typeof column.actions === 'string'
        ? JSON.parse(column.actions)
        : column.actions;
    } catch (e) {
      actionsArray = column.actions;
    }

    // Store the original actions and condition checking method
    const processedColumn = Object.assign({}, column);
    processedColumn.originalActions = actionsArray;
    processedColumn.renderCell = ({ row }) => {
      // Filter actions based on conditions
      const visibleActions = actionsArray.filter((action) =>
        this.shouldShowAction(action, row)
      );

      if (visibleActions.length === 0) return null;
      console.log("row", row);
      return (
        <div style={{ display: 'flex', gap: '8px' }}>
          {visibleActions.map((action, idx) => {
            if (action.type === 'iconButton') {
              return (
                <NewImageButton

                  type={action.icon}

                  onClick={() => {
                    if (action.hasOwnProperty('navigate')) {
                      this.props.history.push({
                        pathname: action.navigate,
                        state: { data: row }
                      });
                    }
                    if (action.hasOwnProperty('onClick')) {
                      action.onClick(row);
                    }
                  }}

                />

              );
            }

            return null;
          })}
        </div>
      );
    };

    return processedColumn;
  }

  getDynamicColumns() {
    const reportConfig = this.getReportConfig();
    const { filterValues } = this.state;
    const { productCustomFields, customerCustomField, vendorCustomField } = this.getReduxState();

    if (!reportConfig) return [];

    const parseRenderCell = (col) => {
      if (col.renderCell && typeof col.renderCell === "string") {

        // Get renderer function by name
        const rendererFunc = getRenderer(col.renderCell);

        if (rendererFunc) {
          return {
            ...col,
            renderCell: ({ row }) => rendererFunc(row)
          };
        }

        // fallback
        console.warn(`Renderer not found: ${col.renderCell}`);
        const { renderCell, ...rest } = col;
        return rest;
      }

      return col;
    };


    const updateHeader = (col) => {
      let name = col.headerName;
      if (name.startsWith('ProductCustomField')) {
        const num = name.replace('ProductCustomField', '');
        const fieldName = productCustomFields && productCustomFields.hasOwnProperty(`CustomField${num}Name`)
          ? productCustomFields[`CustomField${num}Name`]
          : null;
        if (fieldName) return { ...col, headerName: fieldName };
      }
      if (name.startsWith('CustomerCustomField')) {
        const num = name.replace('CustomerCustomField', '');
        const fieldName = customerCustomField && customerCustomField.hasOwnProperty(`CustomField${num}Name`)
          ? customerCustomField[`CustomField${num}Name`]
          : null;
        if (fieldName) return { ...col, headerName: fieldName };
      }
      if (name.startsWith('VendorCustomField')) {
        const num = name.replace('VendorCustomField', '');
        const fieldName = vendorCustomField && vendorCustomField.hasOwnProperty(`CustomField${num}Name`)
          ? vendorCustomField[`CustomField${num}Name`]
          : null;
        if (fieldName) return { ...col, headerName: fieldName };
      }
      return col;
    };

    let cols = [...(reportConfig.hasOwnProperty('columns') ? reportConfig.columns : [])];

    cols = cols.map(col => parseRenderCell(col));
    // Process navigation columns and action columns
    cols = cols.map((col) => {
      if (col.hasOwnProperty('navigate') && col.navigate) {
        return {
          ...col,
          renderCell: ({ row }) => (
            <div
              onClick={() => this.props.history.push(col.navigate, { state: { data: row } })}
              style={{ color: "blue", cursor: "pointer" }}
            >
              {row[col.field]}
            </div>
          )
        };
      }
      // Process action columns with conditional logic
      if (col.type === 'action') {
        return this.processActionColumn(col);
      }
      return col;
    });

    // Handle conditional columns
    if (reportConfig.hasOwnProperty('conditionalColumns') && reportConfig.conditionalColumns) {
      const conditionalColumns = reportConfig.conditionalColumns;
      const entries = Object.entries(conditionalColumns);

      for (let i = 0; i < entries.length; i++) {
        const [field, cfg] = entries[i];
        if (field === 'show') continue;

        if (typeof cfg === 'object' && !Array.isArray(cfg)) {
          const condition = filterValues[field];
          const add = cfg[condition];
          if (add) {
            for (let j = 0; j < add.length; j++) {
              const col = add[j];
              if (col.type === 'action') {
                cols.push(this.processActionColumn(updateHeader(col)));
              } else {
                cols.push(updateHeader(col));
              }
            }
          }
        } else if (Array.isArray(cfg) && filterValues[field]) {
          for (let j = 0; j < cfg.length; j++) {
            const col = cfg[j];
            if (col.type === 'action') {
              cols.push(this.processActionColumn(updateHeader(col)));
            } else {
              cols.push(updateHeader(col));
            }
          }
        }
      }
    }

    const showVal = filterValues && filterValues.show;
    if (showVal &&
      reportConfig.hasOwnProperty('conditionalColumns') &&
      reportConfig.conditionalColumns.hasOwnProperty('show') &&
      reportConfig.conditionalColumns.show &&
      reportConfig.conditionalColumns.show.hasOwnProperty(showVal) &&
      reportConfig.conditionalColumns.show[showVal]) {
      const showColumns = reportConfig.conditionalColumns.show[showVal];
      cols = [];
      for (let i = 0; i < showColumns.length; i++) {
        const col = showColumns[i];
        if (col.type === 'action') {
          cols.push(this.processActionColumn(updateHeader(col)));
        } else {
          cols.push(updateHeader(col));
        }
      }
    }

    const finalCols = [];
    for (let i = 0; i < cols.length; i++) {
      finalCols.push(updateHeader(cols[i]));
    }
    return finalCols;
  }


  getColumns() {
    const generateColumnFromBaceknd = (this.getReportConfig() && this.getReportConfig().hasOwnProperty('generateColumnFromBaceknd') && this.getReportConfig().generateColumnFromBaceknd)
      ? this.getReportConfig().generateColumnFromBaceknd
      : false;
    const { backendColumns } = this.state;
    let columns = (generateColumnFromBaceknd && backendColumns.length) ? backendColumns : this.getDynamicColumns();

    // Process any action columns in the final columns array
    const processedColumns = [];
    for (let i = 0; i < columns.length; i++) {
      const col = columns[i];
      if (col.type === 'action') {
        processedColumns.push(this.processActionColumn(col));
      } else {
        processedColumns.push(col);
      }
    }

    return processedColumns;
  }

  handlePageChange(newPage) {
    this.setState({ currentPage: newPage }, () => {
      // Only refetch if pagination is handled by backend
      const reportConfig = this.getReportConfig();
      const paginationFromBackend = reportConfig && reportConfig.hasOwnProperty('paginationFromBackend')
        ? reportConfig.paginationFromBackend
        : false;

      if (paginationFromBackend) {
        this.fetchDataWithFilters(this.state.filterValues);
      }
    });
  }

  handleRowsPerPageChange(newSize) {
    this.setState({ rowsPerPage: newSize, currentPage: 1 }, () => {
      // Only refetch if pagination is handled by backend
      const reportConfig = this.getReportConfig();
      const paginationFromBackend = reportConfig && reportConfig.hasOwnProperty('paginationFromBackend')
        ? reportConfig.paginationFromBackend
        : false;

      if (paginationFromBackend) {
        this.fetchDataWithFilters(this.state.filterValues);
      }
    });
  }

  render() {
    const { exportLoading, loading, reportData, totalCount, currentPage, rowsPerPage, filterComponents, showStorePopup, isInitialized } = this.state;
    const reportConfig = this.getReportConfig();
    const paginationFromBackend = (reportConfig && reportConfig.hasOwnProperty('paginationFromBackend') && reportConfig.paginationFromBackend) || false;
    const hidePagination = (reportConfig && reportConfig.hasOwnProperty('hidePaignation') && reportConfig.hidePaignation) || false;
    let displayedRows = reportData;
    if (!paginationFromBackend && !hidePagination) {
      displayedRows = reportData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);
    }

    console.log("this.getColumns()", this.getColumns());
    // Don't render until initialized
    if (!isInitialized) {
      return <div>Loading...</div>;
    }

    return (
      <div className="w-full">
        <ReportViewPage
          handleRemoveBtnClick={() => {
            this.props.history.push({
              pathname: "/home",
            });
          }}
          reportConfig={reportConfig}
          filters={filterComponents}
          hideFooter={hidePagination}
          hideApplyFilterButton={(reportConfig && reportConfig.hasOwnProperty('hideApplyFilterButton') && reportConfig.hideApplyFilterButton) || false}
          loading={loading}
          exportLoading={exportLoading}
          footer={
            // Show pagination only when NOT hiding pagination
            !hidePagination && (
              <Pagination
                bordernonee
                count={totalCount}
                page={currentPage}
                rowsPerPage={rowsPerPage}
                onPageChange={this.handlePageChange}
                onRowsPerPageChange={this.handleRowsPerPageChange}
              />
            )
          }
          onExport={this.handleExport}
          onRefresh={this.handleRefresh}
          onApplyFilters={this.handleApplyFilters}
        >
          <CustomTable
            columns={this.getColumns()}
            loading={loading}
            rows={displayedRows}
            loadingRows={25}
            showTextOnRows={displayedRows.length ? null : "No data found!"}
            allowMobilePagination={!hidePagination}
            pagination={{ currentPage, totalCount, rowsPerPage, onPageChange: this.handlePageChange, loading }}
          />
        </ReportViewPage>

        <FloatingWidget
          {...this.props}
          showWidget={this.state.showExportWidget}
          headerText="Download in Progress"

          bodyContent={
            <div>
              <div style={{ fontWeight: "500", marginBottom: "8px" }}>
                {this.state.exportReportName}
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <div className="smallinlinespinner" />
                Preparing your file...
              </div>

              <div style={{ marginTop: "8px" }}>
                📥 Go to <b>Downloaded Reports</b> to get your report.
              </div>
            </div>
          }

          footerContent={
            <div
              style={{ color: "var(--primary-clr)", cursor: "pointer" }}
              onClick={() => { this.props.history.push({ pathname: "/home/reports/download" }); }}
            >
              Open Downloaded Reports →
            </div>
          }
        />

      </div>
    );
  }

}

export default withRouter(Report);